import { Path } from '@/main/router/routerPath';

import { CRUMB_LABEL_KEY, NAME, OBRAT_TYPE, PARTNER_MERGE, VOZIDLO_RIDIC } from './constants';
import List from './List.vue';
import Edit from './Edit.vue';
import Merge from './Merge.vue';
import ObratList from './ObratList.vue';
import SelectList from './SelectList.vue';
import VozidloRidicList from './VozidloRidicList.vue';
import { ZakaznikCDB } from './zakaznikCDB';
import { router as msgLogRouter } from './msgLog/router';

export const router = new Path().addChildren([
	new Path(NAME, { List, Edit, SelectList }, CRUMB_LABEL_KEY),
	new Path(PARTNER_MERGE, { Edit: Merge }, CRUMB_LABEL_KEY),
	new Path(OBRAT_TYPE.SLUZBY, { List: ObratList }, 'grdPartnerObratSluzby'),
	new Path(OBRAT_TYPE.MATERIAL, { List: ObratList }, 'grdPartnerObratMaterial'),
	new Path(OBRAT_TYPE.CELKEM, { List: ObratList }, 'grdPartnerObratCelkem'),
	new Path(VOZIDLO_RIDIC, { SelectList: VozidloRidicList }, VOZIDLO_RIDIC),

	ZakaznikCDB.router,
	msgLogRouter,
]);
